import { Box, Typography } from '@mui/material'

interface Props {
  message?: string
}

export const BlogPostsEmpty = ({ message = 'Không có bài viết nào được tìm thấy' }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 400,
        textAlign: 'center',
        gap: 2,
      }}
    >
      <Box
        sx={{
          width: 120,
          height: 120,
          borderRadius: '50%',
          bgcolor: 'grey.100',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 2,
        }}
      >
        <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z"
            fill="#E0E0E0"
          />
          <path d="M14 2V8H20" fill="#BDBDBD" />
          <path d="M16 13H8V15H16V13Z" fill="#9E9E9E" />
          <path d="M16 17H8V19H16V17Z" fill="#9E9E9E" />
          <path d="M10 9H8V11H10V9Z" fill="#9E9E9E" />
        </svg>
      </Box>
      <Typography variant="h6" color="text.secondary" gutterBottom>
        {message}
      </Typography>
    </Box>
  )
}
